
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/tokens",
      function () {
        return require("private-next-pages/info/tokens.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/tokens"])
      });
    }
  